module.exports = __webpack_public_path__ + "static/media/project1.cf5d9d72.jpg";